module.exports = __webpack_public_path__ + "img/视频封面14.49470dfa.png";